import { Link, SxProps } from "@mui/material";
import { Parameter } from "../../../common/types/parameters";
import { Column } from "../types";
import ParameterSection from "../parameter-section";
import {
  supplementalDistrictHeatingCostSummarySections,
  supplementalDistrictHeatingInputSections,
} from "./supplemental-district-heating-sections";

const HEAT_TECH_PREFIX = "GroundSource";

export default function GroundSourceHeatPump(params: {
  description?: string;
  printTitle: string;
  parameters: Parameter[];
  includeVat: boolean;
  toPrint: boolean;
  onValidParameterChange?: (id: string, value: string) => void;
  onSectionChange?: (targetTab: string) => void;
  sx?: SxProps;
}) {
  return (
    <ParameterSection
      printTitle={params.printTitle}
      toPrint={params.toPrint}
      description={params.description}
      parameters={params.parameters}
      columns={columns(params.onSectionChange)}
      includeVat={params.includeVat}
      onValidParameterChange={params.onValidParameterChange}
      sx={params.sx}
    />
  );
}

const columns = (onSectionChange: ((targetTab: string) => void) | undefined) =>
  [
    {
      sections: [
        {
          title: "Årliga kostnader",
          parameters: [
            "GroundSourceCapitalCost",
            "GroundSourceHeatPumpMaintenanceCost",
            "GroundSourceSupplementalDistrictHeatingTotalCostsSum",
            "GroundSourceEnergyCost",
            "GroundSourceIncreasedGridCost",
          ],
        },
        {
          title: "",
          parameters: ["GroundSourceTotalSpecificCost"],
        },
        ...supplementalDistrictHeatingCostSummarySections(HEAT_TECH_PREFIX),
        {
          title: "Beräknade värden för nytt elabonnemang",
          parameters: [
            "GroundSourceAndBuildingElectricityLoad",
            "GroundSourceFuseDemand",
          ],
        },
      ],
      readOnly: true,
    },
    {
      description: (
        <>
          Prislistor kan justeras på den{" "}
          <Link
            href="#"
            onClick={() => {
              if (onSectionChange !== undefined) {
                onSectionChange("Common");
              }
            }}
          >
            Övergripande
          </Link>{" "}
          fliken.
        </>
      ),
      sections: [
        {
          title: "Detaljerade indata",
          parameters: [
            "GroundSourceHeatingDesignLoad",
            "GroundSourceHeatPumpLoadCoverage",
            "GroundSourceHeatPumpEnergyCoverage",
            "GroundSourceHeatPumpDeliveredHeatingLoad",
            "GroundSourceRemainingHeatingLoad",
            "GroundSourceHeatPumpSCOPRadiator",
            "GroundSourceHeatPumpSCOPFloor",
          ],
        },
        {
          title: "Investeringskostnad",
          parameters: [
            "GroundSourceEnergyWellCost",
            "GroundSourceEnergyWellLifeSpan",
            "GroundSourceHeatPumpCost",
            "GroundSourceHeatPumpLifeSpan",
            "GroundSourceMiscellaneousCost",
            "GroundSourceMiscellaneousLifeSpan",
          ],
        },
        {
          title: "Drift- och underhållskostnader",
          parameters: ["GroundSourceHeatPumpMaintenanceCost"],
        },
        ...supplementalDistrictHeatingInputSections(HEAT_TECH_PREFIX),
      ],
    },
  ] as Column[];
